import { createFileRoute } from '@tanstack/react-router';

// Layout-маршрут: проверка доступа для всех /curriculum/*
// Компонент вынесен в curriculum.lazy.tsx — раздел грузится отдельным бандлом
export const Route = createFileRoute('/curriculum')({});
